import { Row } from "antd";
import { ISelectedConversation } from "../../types/SelectedConversation";
import { Chat } from "../Chat";
import { InputMessage } from "../Chat/components/InputMessage";
import { useMemo, useState } from "react";
import { Header } from "./Header";
import { useSend } from "../Chat/hooks/useSend";

type MessagesSideProps = {
  conversation: ISelectedConversation;
  setConversation: React.Dispatch<
    React.SetStateAction<ISelectedConversation | null>
  >;
};

export const MessagesSide = ({
  conversation,
  setConversation,
}: MessagesSideProps) => {
  const showInput: boolean = useMemo(
    () => !conversation.isArchived && conversation.type === 1,
    [conversation]
  );

  const [initErr, setInitErr] = useState<string | null>(null);

  const [conversationId, setConversationId] = useState<string | undefined>(
    undefined
  );

  const {
    form,
    respose: mineNew,
    isSending,
    onMsgSent,
    send,
  } = useSend(conversationId);

  return (
    <>
      <Header conversation={conversation} setConversation={setConversation} />
      <Chat
        initErr={initErr}
        parentId={conversation.id}
        isArchived={conversation.isArchived}
        conversationId={conversationId}
        mineNew={mineNew}
        setConversationId={setConversationId}
        setInitErr={setInitErr}
        onMsgSent={onMsgSent}
      />

      {showInput && !initErr && (
        <Row className="chat-input w-100">
          <InputMessage form={form} isSending={isSending} send={send} />
        </Row>
      )}
    </>
  );
};
